import React, { FC } from 'react';
import  styles from './CalendarToday.module.scss';


interface CalendarTodayProps {}

const CalendarToday: FC<CalendarTodayProps> = () => {
  return (
 <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M17.5 2.25C17.5 1.97386 17.2761 1.75 17 1.75C16.7239 1.75 16.5 1.97386 16.5 2.25V3.25H8.5V2.25C8.5 1.97386 8.27614 1.75 8 1.75C7.72386 1.75 7.5 1.97386 7.5 2.25V3.25H5C4.30964 3.25 3.75 3.80964 3.75 4.5V8.25V19.5C3.75 20.1904 4.30964 20.75 5 20.75H20C20.6904 20.75 21.25 20.1904 21.25 19.5V8.25V4.5C21.25 3.80964 20.6904 3.25 20 3.25H17.5V2.25ZM20.25 7.75V4.5C20.25 4.36193 20.1381 4.25 20 4.25H17.5V5.25C17.5 5.52614 17.2761 5.75 17 5.75C16.7239 5.75 16.5 5.52614 16.5 5.25V4.25H8.5V5.25C8.5 5.52614 8.27614 5.75 8 5.75C7.72386 5.75 7.5 5.52614 7.5 5.25V4.25H5C4.86193 4.25 4.75 4.36193 4.75 4.5V7.75H20.25ZM4.75 8.75H20.25V19.5C20.25 19.6381 20.1381 19.75 20 19.75H5C4.86193 19.75 4.75 19.6381 4.75 19.5V8.75Z" fill="#ED723D"/>
</svg>

  );
};



export default CalendarToday;
